<style scoped>
.preview-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 70vh;
}
</style>

<template>
  <b-modal
    id="pdf-signature-modal"
    header-class="anchor-modal"
    ref="pdfSignatureModal"
    :title="`${title} - Signature`"
    hide-footer
    size="lg"
  >
    <b-row>
      <b-col>
        <div class="preview-container">
          <iframe
            v-if="link"
            :src="link"
            width="100%"
            height="100%"
          >
          </iframe>
        </div>
      </b-col>
    </b-row>
  </b-modal>
</template>


<script>

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      link: null,
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
  },
  methods: {
    show(link) {
      if (link) {
        this.link = link;
        this.$refs.pdfSignatureModal.show();
      }
    },
    hide() {
      this.link = null;
      this.$refs.pdfSignatureModal.hide();
    },
  },
  mounted() {
    window.onmessage = (e) => {
      if (e.data === 'close-signature-modal') {
        this.$notify({
          group: 'alert',
          text: 'Document was successfully signed and submitted for review.',
          type: 'success',
          duration: -1,
          closeOnClick: true,
        });
        this.$emit('pdf-signed');
        this.hide();
      }
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/utils/PdfSignature.vue